import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import moment from 'moment';
import PromoMessage from '../promo-message';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.signs_map = {
            general: 0,
            aries: 1,
            taurus: 2,
            gemini: 3,
            cancer: 4,
            leo: 5,
            virgo: 6,
            libra: 7,
            scorpio: 8,
            sagittarius: 9,
            capricorn: 10,
            aquarius: 11,
            pisces: 12,
        };

        let sign = props.sign || 'general';

        if (props.user.logged_in && !props.sign) {
            sign = props.signs[props.user.default_sign - 1].name;
        }

        this.state = { sign: sign };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.user.logged_in != this.props.user.logged_in) {
            if (nextProps.user.logged_in && !this.props.sign) {
                this.setState({ sign: this.props.signs[nextProps.user.default_sign - 1].name });
            } else if (!nextProps.user.logged_in && !this.props.sign) {
                this.setState({ sign: 'general' });
            }

            return true;
        } else if (nextState.sign != this.state.sign) {
            return true;
        }

        return false;
    }

    /* eslint-disable max-len */
    render({ horoscopes, date, actual_sign }) {
        const last_week = moment().day(1).subtract(1, 'week').format('YYYY-MM-DD');
        const this_week = moment().day(1).format('YYYY-MM-DD');
        const next_week = moment().day(1).add(1, 'week').format('YYYY-MM-DD');

        if (horoscopes) {
            return (
                <weekly-love-horoscope date={date}>
                    <div className={`daily-links ${actual_sign == 'general' ? 'has-margin-10-top has-margin-15-top-mobile' : ''}`}>
                        <a
                            href={`/astrology/weekly-love-horoscopes/${this.state.sign}/${last_week}`}
                            className={last_week == date ? 'selected' : ''}
                            onClick={() => this.trackClick('Last Week')}
                        >
                            Last Week
                        </a>
                        <a
                            href={`/astrology/weekly-love-horoscopes/${this.state.sign}/${this_week}`}
                            className={this_week == date ? 'selected' : ''}
                            onClick={() => this.trackClick('This Week')}
                        >
                            This Week
                        </a>
                        <a
                            href={`/astrology/weekly-love-horoscopes/${this.state.sign}/${next_week}`}
                            className={next_week == date ? 'selected' : ''}
                            onClick={() => this.trackClick('Next Week')}
                        >
                            Next Week
                        </a>
                    </div>
                    {this.renderSubLinks()}
                    {this.renderHeading()}
                    <div className='daily-links has-margin-17-bottom'>
                        <a
                            href='/bios/maria-desimone'
                            onClick={() => this.trackClick('by Maria DeSimone')}
                        >
                                by Maria DeSimone
                        </a>
                    </div>
                    <br />
                    {this.renderHoroscope()}
                </weekly-love-horoscope>
            );
        }

        return (<weekly-love-horoscope />);
    }
    /* eslint-enable max-len */

    renderSubLinks = () => {
        if (this.props.actual_sign == 'general') {
            const monthlyDate = moment();
            if (monthlyDate.date() > 27) {
                monthlyDate.add(1, 'months');
            }

            const links = [
                {
                    route: '/readings-reports/subscription/vip-membership',
                    title: 'VIP Horoscopes',
                },
                {
                    route: '/daily-love-horoscope',
                    title: 'Daily Love',
                },
                {
                    route: `/horoscopes/monthly/${monthlyDate.format('MMMM-YYYY')}`,
                    title: 'Monthly',
                },
                {
                    route: `/horoscopes/${moment().format('YYYY')}`,
                    title: 'Yearly',

                },
            ];

            return (
                <row className='is-wrap is-aligned-center has-margin-15-top has-margin-15-bottom'>
                    <column className='is-12-mobile has-padding-5-top'>
                        <span className='has-margin-13-right'>More Horoscopes:</span>
                    </column>
                    <column className='is-12-mobile has-padding-5-top'>
                        {links.map((link) => {
                            return (
                                <a
                                    className='has-margin-13-right'
                                    href={link.route}
                                    onClick={() => this.trackClick(link.title)}
                                >
                                    {link.title}
                                </a>
                            );
                        })}
                    </column>
                </row>
            );
        }

        return null;
    }

    renderHeading = () => {
        const title = `${this.state.sign.charAt(0).toUpperCase()}${this.state.sign.slice(1)} Weekly Love Horoscope`;

        if (this.props.actual_sign == 'general') {
            return (<h2 className='is-h1'>{title}</h2>);
        }

        return (<h1>{title}</h1>);
    }

    renderHoroscope = () => {
        return [
            <p>
                <b>Week of {moment(this.props.date).format('dddd, MMMM D')}: </b>
                {this.props.horoscopes[this.signs_map[this.state.sign]].content}
            </p>,
            <p>
                <PromoMessage placement='text' tags='love,weekly' />
            </p>,
        ];
    }

    trackClick = (text) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = `Text - ${text}`;

        this.props.trackEvent(['Daily Nav', action, label]);
    }
}

const mapStateToProps = (state) => ({
    horoscopes: state['weekly-love-horoscopes'],
    signs: state.zodiac && state.zodiac.signs,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
